
import Dashboard from "views/Dashboard.js";
import Notifications from "views/Notifications.js";
import Support from "views/Support";
import TableList from "views/Tables.js"; 
import UserPage from "views/User.js";

import { ReactComponent as DashboardIcon } from "../src/assets/img/category.svg";
import { ReactComponent as TransactionIcon } from "../src/assets/img/TransactionIconVector.svg";
import { ReactComponent as SettingIcon }from "../src/assets/img/setVector.svg";
import { ReactComponent as PushIcon }from "../src/assets/img/notification.svg";
import { ReactComponent as SupportIcon } from "../src/assets/img/supVector.svg";


var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: DashboardIcon ,
    component: <Dashboard />,
    layout: "/user",
  },
  {
    path: "/tables",
    name: "Transaction",
    icon: TransactionIcon ,
    component: <TableList />,
    layout: "/user",
  },
  {
    path: "/user-page",
    name: "Settings",
    icon: SettingIcon ,
    component: <UserPage />,
    layout: "/user",
  },
  {
    path: "/notifications",
    name: "Push Notifications",
    icon: PushIcon ,
    component: <Notifications />,
    layout: "/user",
    
  },
  {
    path: "/support",
    name: "Support",
    icon: SupportIcon ,
    component: <Support />,
    layout: "/user",
    
  }
];
export default routes;
